var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ai-status",class:`is-${_vm.normalized}`},[_c('i'),_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }